import React from 'react';
import { apiVariables } from '../utils/variables';
var dateFormat = require('dateformat');

export class LogViewer extends React.Component{
    constructor(props){
        super(props);
        this.getLogs = this.getLogs.bind(this);
        this.state = {logs: null};
    }
    componentDidMount(){
        this.getLogs();
    }
    getLogs(){
        fetch( apiVariables.apiLink + 'solutionmonitor/logs?organization=' + encodeURIComponent(this.props.CurrentOrganization) + '&solutionName=' + encodeURIComponent(this.props.solutionName), { 
        method: 'get',
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        })
        .then((response) => response.json())
        .then((responseJson) => {
            console.log(responseJson)
            this.setState({logs: responseJson.document.logs});

        });
    }
    render(){
        if(this.state.logs != null){
            return (
            <table className="table table-bordered table-hover col-xl-12">
                <thead>
                <tr>
                    <th data-field="TimeStamp" data-sortable="true">TimeStamp</th>
                    <th className="text-center">Event</th>
                    <th className="text-center">To Status</th>
                    <th className="text-center">User</th>
                    <th className="text-center">Flow</th>
                    
                </tr>
                </thead>
                {this.state.logs.map(((log, index) =>
                    <LogRows key={index} log={log}/>
                ))}
                
            </table>
          );
        }   
        else{
            return <h1>Fetching Logs</h1>;
        }
    }
}

class LogRows extends React.Component{
    constructor(props){
        super(props);
        this.state = {shown: false};
        this.showHandler = this.showHandler.bind(this);
    }
    showHandler(e){
        this.setState({shown: !this.state.shown});
    }
    render(){
        return(
        <tbody>
            <tr className="hover" onClick={this.showHandler}>
                <td>{ dateFormat(this.props.log.logTime, "dS mmmm, yyyy, HH:MM:ss") }</td>
                <td>{ this.props.log.eventName }</td>
                <td>{ this.props.log.toStatus }</td>
                <td>{ this.props.log.currentUser }</td>
                <td>{ this.props.log.flow }</td>	
        
            </tr>
            <tr>
                <td colSpan={5} className={this.state.shown ? "acccordian-body hiddenRow" : " hiddenRowaccordian-body hidden"}>
                    <div className="col-md-12 accordion ">
                        <table className = "table ">
                            <thead>
                            <tr><th className="text-center logDetails">Reason</th></tr>
                            </thead>
                            <tbody>
                                <tr className="logDetails"><td>{ this.props.log.reason }</td></tr>
                            </tbody>
                        </table>   
                    </div>
                </td>
            </tr>
        </tbody>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/stateChangeLogs.js